module.exports = __webpack_public_path__ + "img/crazy_horse.04e56d24.jpg";